module.exports = __webpack_public_path__ + "img/car.9a847a9c.png";